import './escapefomo.css';
import React, { useState } from 'react';
import { addDoc, collection, getDocs, query, where } from "firebase/firestore";
import { db } from '../../firebase';

const EscapeFomo = () => {
  const [email, setEmail] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const [successMessage, setSuccessMessage] = useState('');
  const [emailError, setEmailError] = useState('');

  const checkIfEmailExists = async (email) => {
    const emailQuery = query(collection(db, "newsletter"), where("email", "==", email));
    const emailSnapshot = await getDocs(emailQuery);
    return !emailSnapshot.empty;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setEmailError(''); // Reset email error
    setSuccessMessage(''); // Reset success message

    try {
      const emailExists = await checkIfEmailExists(email);

      if (emailExists) {
        setEmailError('Tu es déjà abonné(e) à notre newsletter.');
        setIsLoading(false);
        return; // Sortie anticipée si l'email existe déjà
      }

      // Ajout de l'email à la collection "newsletter" dans Firestore
      await addDoc(collection(db, 'newsletter'), {
        email: email,
        addedAt: new Date(),
      });

      // Réinitialiser l'input et les états après le succès
      setEmail('');
      setIsLoading(false);
      setIsSuccess(true);
      setSuccessMessage('Tu es maintenant abonné(e) à notre newsletter.');
    } catch (error) {
      setIsLoading(false);
      setEmailError('Une erreur est survenue lors de l\'inscription. Veuillez réessayer.');
      console.error('Erreur lors de l\'enregistrement : ', error);
    }
  };

  return (
    <div className='flex flex-col lg:gap-[25px] gap-[12px] font-chido'>
      <p className="lg:text-[65px] text-[16px]">ESCAPE THE FOMO</p>

      <form onSubmit={handleSubmit} className="flex lg:gap-[25px] gap-2.5 lg:h-[100px] w-full">
        <input
          className="flex lg:p-3 p-2 w-4/6 lg:border-[6px] border-[4px] border-offblack bg-transparent text-offblack lg:rounded-[20px] rounded-[5px] h-full lg:text-[24px] text-[12px] escfinput"
          placeholder='TYPE YOUR EMAIL TO KEEP IN TOUCH'
          type="email"
          name="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
        />

        <button className="flex items-center justify-center w-2/6 lg:border-[6px] border-[4px] border-offblack bg-genyellow text-offblack lg:rounded-[20px] rounded-[5px] lg:h-full h-auto lg:text-[35px]" disabled={isLoading}>
          {isLoading ? 'Loading...' : "LET'S GO..."}
        </button>
      </form>

      {/* Affichage du message de succès */}
      {isSuccess && successMessage && (
        <p className="font-concretica text-lightgreen lg:text-[18px] text-[12px] mt-2">{successMessage}</p>
      )}

      {/* Affichage du message d'erreur */}
      {emailError && (
        <p className="font-concretica text-red-500 lg:text-[18px] text-[12px] mt-2">{emailError}</p>
      )}

      <p className="font-concretica text-offblack lg:text-[12px] text-[10px]">*By subscribing, you agree to receive communications from BIAM Entertainment Group.</p>
    </div>
  );
};

export default EscapeFomo;
